/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStoreReportQuery } from '../../models/get-store-report-query';
import { GetStoreReportQueryResult } from '../../models/get-store-report-query-result';

export interface ApiNurseryManagerReportsGetStoreReportPost$Plain$Params {
      body?: GetStoreReportQuery
}

export function apiNurseryManagerReportsGetStoreReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetStoreReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStoreReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetStoreReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStoreReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetStoreReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetStoreReport';
